import {
  AddPageContentRequest,
  AddPageRequest,
  ImportDetails,
  PageCollection,
  PageContentResponse,
  PageDetails
} from '../models/api';
import { deleteData, getData, postData, postFile, putData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const list = async (): Promise<ResponseData<PageCollection>> =>
  getData<PageCollection>('api/content/pages');
export const get = async (
  pageReference: string
): Promise<ResponseData<PageDetails>> =>
  getData<PageDetails>(`api/content/pages/${pageReference}`);
export const add = async (
  model: AddPageRequest
): Promise<ResponseData<PageDetails>> =>
  postData<PageDetails>('api/content/pages', model);
export const update = async (
  pageReference: string,
  model: AddPageRequest
): Promise<ResponseData<PageDetails>> =>
  putData<PageDetails>(`api/content/pages/${pageReference}`, model);
export const remove = async (
  pageReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  deleteData(`api/content/pages/${pageReference}`);

export const getContents = async (
  pageReference: string
): Promise<ResponseData<PageContentResponse>> =>
  getData<PageContentResponse>(`api/content/pages/${pageReference}/contents`);
export const updateContents = async (
  pageReference: string,
  model: AddPageContentRequest
): Promise<ResponseData<PageContentResponse>> =>
  postData<PageContentResponse>(
    `api/content/pages/${pageReference}/contents`,
    model
  );

export const importWord = async (
  file: File
): Promise<ResponseData<ImportDetails>> =>
  postFile<ImportDetails>('api/content/import/word', file);
